import { helper } from "@ember/component/helper"
import type { Permission } from "@shared/models/permissions"
import { includes } from "lodash-es"

export function permissionsInclude(permissions: Array<Permission>, permission: Permission) {
  return includes(permissions, permission)
}

const permissionsIncludeHelper = helper(function (args: [Array<Permission>, Permission]) {
  let [permissions, perm] = args
  return permissionsInclude(permissions, perm)
})

export default permissionsIncludeHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "permissions-include": typeof permissionsIncludeHelper
  }
}
